import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// TODO: replace with complaintTypeId from the create/select-type API when it exists.
// Unused: NewQuery has its own local fallback, and complaint types use redux/complaintType.
// export const DEFAULT_COMPLAINT_TYPE_ID = 32;

export const COMPLAINT_ENDPOINTS = Object.freeze({
  // Unused: replaced by redux/complaintType, Workflow, and status modules.
  // types: '/api/v1/complaints/types',
  // departments: '/api/v1/complaints/departments',
  // departmentTree: '/api/v1/complaints/departments/tree',
  // priorities: '/api/v1/complaints/priorities',
  // workflows: '/api/v1/complaints/workflows',
  // workflowSteps: '/api/v1/complaints/workflows/steps',
  // statuses: '/api/v1/complaints/statuses',
  formFields: (complaintTypeId) =>
    `/api/v1/complaint-types/${complaintTypeId}/form-fields`,
});

const rejectMessage = (error) => {
  const data = error?.response?.data;
  const raw = data?.message ?? data?.error ?? error?.message;
  if (Array.isArray(raw)) return raw.filter(Boolean).join(', ');
  if (raw && typeof raw === 'object') return raw.message ?? JSON.stringify(raw);
  return raw || 'Something went wrong';
};

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message: rejectMessage(error),
  });

const request = (type, handler) =>
  createAsyncThunk(type, async (params, thunkApi) => {
    try {
      const response = await handler(params, thunkApi);
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  });

// Unused: generic CRUD was replaced by separate redux modules.
// const resourceActions = (resource, endpoint) => ({
//   list: request(`complaint/${resource}/list`, (params, { signal }) =>
//     api.get(endpoint, { params, signal }),
//   ),
//   getById: request(`complaint/${resource}/getById`, (id, { signal }) =>
//     api.get(`${endpoint}/${id}`, { signal }),
//   ),
//   create: request(`complaint/${resource}/create`, (payload) =>
//     api.post(endpoint, payload),
//   ),
//   update: request(`complaint/${resource}/update`, ({ id, data }) =>
//     api.patch(`${endpoint}/${id}`, data),
//   ),
//   remove: request(`complaint/${resource}/remove`, (id) =>
//     api.delete(`${endpoint}/${id}`),
//   ),
// });

// export const complaintTypeActions = resourceActions(
//   'types',
//   COMPLAINT_ENDPOINTS.types,
// );
// export const complaintDepartmentActions = resourceActions(
//   'departments',
//   COMPLAINT_ENDPOINTS.departments,
// );
// export const complaintPriorityActions = resourceActions(
//   'priorities',
//   COMPLAINT_ENDPOINTS.priorities,
// );
// export const complaintWorkflowActions = resourceActions(
//   'workflows',
//   COMPLAINT_ENDPOINTS.workflows,
// );
// export const complaintStatusActions = resourceActions(
//   'statuses',
//   COMPLAINT_ENDPOINTS.statuses,
// );

// export const getDepartmentTree = request(
//   'complaint/departments/getTree',
//   (_params, { signal }) =>
//     api.get(COMPLAINT_ENDPOINTS.departmentTree, { signal }),
// );

// export const getWorkflowSteps = request(
//   'complaint/workflows/getSteps',
//   (workflowId, { signal }) =>
//     api.get(`${COMPLAINT_ENDPOINTS.workflowSteps}/${workflowId}`, { signal }),
// );

export const getFormFields = request(
  'complaint/types/getFormFields',
  (complaintTypeId, { signal }) =>
    api.get(COMPLAINT_ENDPOINTS.formFields(complaintTypeId), { signal }),
);

export const saveFormFields = request(
  'complaint/types/saveFormFields',
  ({ complaintTypeId, data }) =>
    api.put(COMPLAINT_ENDPOINTS.formFields(complaintTypeId), data),
);

export const deleteFormField = request(
  'complaint/types/deleteFormField',
  ({ complaintTypeId, fieldId }) => 
    api.delete(`${COMPLAINT_ENDPOINTS.formFields(complaintTypeId)}/${fieldId}`),
);

// Unused: workflow steps are handled by redux/Workflow.
// export const saveWorkflowSteps = request(
//   'complaint/workflows/saveSteps',
//   (payload) => api.post(COMPLAINT_ENDPOINTS.workflowSteps, payload),
// );

// export const deleteWorkflowSteps = request(
//   'complaint/workflows/deleteSteps',
//   (workflowId) =>
//     api.delete(`${COMPLAINT_ENDPOINTS.workflowSteps}/${workflowId}`),
// );

// Unused aliases: complaint types/departments/priorities/workflows/statuses
// now live in their own actions.js files.
// Product-module style named exports for consumers that prefer direct thunks.
// export const getComplaintTypes = complaintTypeActions.list;
// export const getComplaintTypeById = complaintTypeActions.getById;
// export const createComplaintType = complaintTypeActions.create;
// export const updateComplaintType = complaintTypeActions.update;
// export const deleteComplaintType = complaintTypeActions.remove;
// export const getComplaintDepartments = complaintDepartmentActions.list;
// export const getComplaintDepartmentById = complaintDepartmentActions.getById;
// export const createComplaintDepartment = complaintDepartmentActions.create;
// export const updateComplaintDepartment = complaintDepartmentActions.update;
// export const deleteComplaintDepartment = complaintDepartmentActions.remove;
// export const getComplaintPriorities = complaintPriorityActions.list;
// export const getComplaintPriorityById = complaintPriorityActions.getById;
// export const createComplaintPriority = complaintPriorityActions.create;
// export const updateComplaintPriority = complaintPriorityActions.update;
// export const deleteComplaintPriority = complaintPriorityActions.remove;
// export const getComplaintWorkflows = complaintWorkflowActions.list;
// export const getComplaintWorkflowById = complaintWorkflowActions.getById;
// export const createComplaintWorkflow = complaintWorkflowActions.create;
// export const updateComplaintWorkflow = complaintWorkflowActions.update;
// export const deleteComplaintWorkflow = complaintWorkflowActions.remove;
// export const getComplaintStatuses = complaintStatusActions.list;
// export const getComplaintStatusById = complaintStatusActions.getById;
// export const createComplaintStatus = complaintStatusActions.create;
// export const updateComplaintStatus = complaintStatusActions.update;
// export const deleteComplaintStatus = complaintStatusActions.remove;
